import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Alert,
  AlertIcon,
  AlertDescription,
} from '@chakra-ui/react'
import { useFeatureToggle } from '../../common/utils/feature-toggle/useFeatureToggle'
import ClientSSOContext, { SSO_PROVIDER_TYPE } from '../../features/sso/types/ClientSSOContext'
import SSOOIDCAuthenticationModal from './SSOOIDCAuthenticationModal'
import SSOSamlAuthenticationModal from './SSOSamlAuthenticationModal'

export interface SSOAuthenticationModalProps {
  isOpen: boolean
  onClose: () => void
  onSuccess: () => void
  onError?: (error: string) => void
}

const SSOAuthenticationModal = ({
  isOpen,
  onClose,
  onSuccess,
  onError,
}: SSOAuthenticationModalProps) => {
  const clientSSOContextDataString = localStorage.getItem('clientSSOContext')
  const clientSSOContextData: ClientSSOContext | null = clientSSOContextDataString
    ? JSON.parse(clientSSOContextDataString)
    : null

  const { isFeatureEnabled: isSSOSAMLReauthenticationFeatureOn } = useFeatureToggle(
    'SSO_SAML_REAUTHENTICATION'
  )

  if (!clientSSOContextData) {
    return (
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>SSO Authentication</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Alert status="error">
              <AlertIcon />
              <AlertDescription>
                No SSO client context found. Please refresh the page and try again.
              </AlertDescription>
            </Alert>
          </ModalBody>
          <ModalFooter>
            <Button onClick={onClose}>Close</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    )
  }

  if (
    clientSSOContextData.providerType === SSO_PROVIDER_TYPE.SAML &&
    isSSOSAMLReauthenticationFeatureOn
  ) {
    return <SSOSamlAuthenticationModal isOpen={isOpen} onClose={onClose} onSuccess={onSuccess} />
  }

  return (
    <SSOOIDCAuthenticationModal
      isOpen={isOpen}
      onClose={onClose}
      onSuccess={onSuccess}
      onError={onError}
    />
  )
}

export default SSOAuthenticationModal
